var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "managedongoingworkflow",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_ongoingList: null,
	_who: null,
	_who_tracker: null,

	track: track,
	recalculate: recalculate,
	refresh: refresh,
	updateOngoing: updateOngoing,
});

function init() {
	this._ongoingList = [];
	this._who = null;
	this._who_tracker = this.dispatcher.createTracker();
	this.push([]);
}

function uninit() {
	this._ongoingList = null;
	this._who_tracker.off();
	this._who_tracker = null;
}

function triggers() {
	return {
		"load": handle_ongoing_history,
		"reset": handle_reset
	};
}

function listeners() {
	return {
		"connectivity:online": refresh,
	};
}

function handle_ongoing_history(data) {
	this._who = data.who;
	this._group = data.group;
	if(!data.who) return;

	this.track();
	this.refresh();

	this.emit("usermetrics:trigger:track", "open ongoing pathway", {
		who: data.who,
	});
}

function handle_reset() {
	this._who = null;
	this._group = null;
	this._ongoingList = [];
	this._who_tracker.off();
	this.push([]);
	this.emit("usermetrics:trigger:track", "close ongoing pathway");
}


function finish_load() {
	this.emit("save:trigger:finish");
}

function recalculate() {
	var ongoingList = this._ongoingList;

	const actors = ongoingList.reduce((result, item) => {
		item.actors.forEach(actor => {
			if(actor?.type !== "manageGroup")
				result.add(actor.who);
		});
		return result;
		// eslint-disable-next-line no-undef
	}, new Set());

	const people = Array.from(actors);

	this.emit("people:trigger:add", {
		who: people,
		lean: true
	});

	this.push(ongoingList);
}

function track() {
	var who = this._who;
	var tracker = this._who_tracker;
	var group = this._group;

	tracker.off();
	if(group) {
		if(Array.isArray(group)) {
			group.forEach(g=>{
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/workflow/created", add_ongoing.bind(this));
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/workflow/finished", remove_ongoing.bind(this));
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/workflow/ongoing/state/updated", update_state.bind(this));
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/workflow/ongoing/actors/added", add_actor.bind(this));
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/workflow/ongoing/actors/removed", remove_actor.bind(this));
			});
		} else {
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/workflow/created", add_ongoing.bind(this));
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/workflow/finished", remove_ongoing.bind(this));
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/workflow/ongoing/state/updated", update_state.bind(this));
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/workflow/ongoing/actors/added", add_actor.bind(this));
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/workflow/ongoing/actors/removed", remove_actor.bind(this));
		}
	} else {
		tracker.on("mqtt:u/" + who + "/workflow/created", add_ongoing.bind(this));
		tracker.on("mqtt:u/" + who + "/workflow/finished", remove_ongoing.bind(this));
		tracker.on("mqtt:u/" + who + "/workflow/ongoing/state/updated", update_state.bind(this));
		tracker.on("mqtt:u/" + who + "/workflow/ongoing/actors/added", add_actor.bind(this));
		tracker.on("mqtt:u/" + who + "/workflow/ongoing/actors/removed", remove_actor.bind(this));
	}
}

function updateOngoing(ongoingId, fn) {
	this._ongoingList = this._ongoingList.map(function(item){
		if(item._id !== ongoingId) return item;
		return fn(item);
	});
	this.recalculate();
}

function add_ongoing(data){
	this._ongoingList = this._ongoingList.concat(data);
	this.recalculate();
}

function remove_ongoing(data){
	var id = data._id;

	this._ongoingList = this._ongoingList.filter(function(item){
		return item._id !== id;
	});

	this.recalculate();
}

function add_actor(data) {
	var ongoingId = data.ongoing;
	var actor = data.actor;
	var who = data.who;
	const type = data.type;

	this.updateOngoing(ongoingId, function(item){
		return xtend(item, {
			actors: item.actors.concat({
				actor: actor,
				who: who,
				...(type && {type})
			})
		});
	});
}

function remove_actor(data) {
	var ongoingId = data.ongoing;
	var actor = data.actor;
	var who = data.who;

	this.updateOngoing(ongoingId, function (item) {
		return xtend(item, {
			actors: item.actors.filter(function(existing){
				return !((existing.actor === actor) && (existing.who == who));
			})
		});
	});
}

function update_state(data){
	var ongoingId = data.ongoing;
	var state = data.state;

	this.updateOngoing(ongoingId, function(item){
		return xtend(item, {
			state: state
		});
	});
}

function refresh() {
	var managee = this._who;
	var group = this._group;
	if(!managee) return;

	this.emit("save:trigger:start");
	this.api.manage.workflow
		.ongoing(managee, group)
		.then(Model.makeRecalculator("ongoingList").bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}
